export default __webpack_public_path__ + "static/media/kanipakamPlacesTwo.2537ab0e.png";